import React from 'react'
import { subscribe } from 'react-contextual'
import AgencySwitcherProvider from '../../AgencySwitcherProvider'

interface AgencySwitcherButtonProps {
  openAgencySwitcherModal: () => void
}

const SupportStaffButton = ({ openAgencySwitcherModal }: AgencySwitcherButtonProps) => {
  return (
    <button id="agency-switcher-button" onClick={openAgencySwitcherModal}>
      Switch agency
    </button>
  )
}

export default subscribe([AgencySwitcherProvider], ({ openAgencySwitcherModal }: AgencySwitcherButtonProps) => ({
  openAgencySwitcherModal,
}))(SupportStaffButton)
